/**
 * class to handle HTTP Requests and Token refresh
 */

import querystring from 'querystring';
import jwt_decode from "jwt-decode";
import { getData } from '../../utils/commons';
import { configuration } from '../../config/main.config';
export const httpUtil = {
	setupChannel,
	put,
	post,
	get,
	sendDelete,
	is200OK,
	startSession,
	getSession,
	cleanObj,
	cleanSession,
	uploadFileNew,
};


/** local variables */

let _storeKVFn;
let _getKVFn;
let _sessionInvalidCallback;
let _accessToken;
let _refreshToken;
let _host;
let _sessionData;
let _apiKey;

let _selfServicePath = '/self-service'
let _backofficePath = '/backoffice'
/**
 * 
 * TODO: do we need a call back for no internet connection ?
 * when no connection refresh token will not be available -> should not kick user out.
 */
function initOptionHeader() {
	return {
		'User-Agent': 'request',
		'Content-Type': 'application/json; charset=utf-8',
	}
}

async function setupChannel({
	storeKVFn,  //function to store key value
	getKVFn,    //function to get value by key from the storage
	sessionInvalidCallback, //function to call when api_key or token key is invalid and refresh token if available was failed
	apiKey,
	host
}) {
	_storeKVFn = storeKVFn;
	_getKVFn = getKVFn;
	_sessionInvalidCallback = sessionInvalidCallback;
	_apiKey = apiKey;
	_host = host;
	if (_getKVFn) {
		_accessToken = await _getKVFn('access_token');
		try {
			if (_accessToken) {
				_sessionData = jwt_decode(_accessToken);
			}
		} catch (e) {
			console.log('Failed to load session data: ', e);
			_sessionData = undefined;
		}
	}
	//TODO add silent refresh token here
}

function startSession({ access_token, refresh_token }) {
	//TODO handle expiration
	_accessToken = access_token;
	_refreshToken = refresh_token;
	if (_storeKVFn) {
		_storeKVFn("access_token", access_token)
		_storeKVFn("refresh_token", refresh_token)
		// _storeKVFn("exp", exp)
		//parse and store session data
		_sessionData = jwt_decode(_accessToken);
		console.log('Session data:', _sessionData);
	}
}

function cleanSession() {
	//TODO handle expiration
	_accessToken = undefined;
	if (_storeKVFn) {
		_storeKVFn("access_token", undefined)
		//parse and store session data
		console.log('Session cleared');
	}

}

function getSession() {
	return _sessionData;
}

function getURI(isBackend, resourcePath) {
	if (isBackend == true)
		return _host + _backofficePath + resourcePath;
	else
		return _host + _selfServicePath + resourcePath;
}

function json2Obj(str) {
	try {
		return JSON.parse(str);
	} catch (e) {
		return null;
	}
}

async function post({
	resourcePath,
	body,
	queryParams,
	logOutIfSessionInvalid = true,
	version,
	unauthorize = false,
	isBackend = false,
	withAccessToken = false,
	accessToken,
}) {
	let uri = getURI(isBackend, resourcePath);
	var options = {};
	options.headers = initOptionHeader();
	options.method = "POST";
	options.credentials = 'omit';
	if (withAccessToken == true || logOutIfSessionInvalid == true) {
		if (accessToken) options.headers['Authorization'] = 'Bearer ' + accessToken;
		else options.headers['Authorization'] = 'Bearer ' + _accessToken;
	}
	else if (!unauthorize) {
		options.headers['api_key'] = _apiKey;
	}
	if (configuration.x_language)
		options.headers.x_language = getData('LANGUAGE');

	if (version || configuration.apiVersion)
		options.headers.x_version = version ? version : configuration.apiVersion;


	if (body)
		options.body = JSON.stringify(body);
	if (queryParams)
		uri = uri + '?' + querystring.encode(queryParams);
	console.log('POST: ', uri, options);
	let response = await fetch(uri, options);
	let bodyText = await response.text()
	console.log('Response - ', response.status, ' - Body:', (bodyText ? json2Obj(bodyText) : bodyText));
	if (response.status == '200'|| (response.status >= '200' && response.status <= '299')) {
		return { code: "OK", data: bodyText ? json2Obj(bodyText) : null };
	} else {
		validateForceLogout(response, logOutIfSessionInvalid);
		return { code: response.status, bodyText: bodyText, error: json2Obj(bodyText) };
	}

}

async function validateForceLogout(response, logOutIfSessionInvalid) {
	try {
		if (logOutIfSessionInvalid == true && _sessionInvalidCallback && response.status == '401') {
			await _sessionInvalidCallback();
			cleanSession();
		}

	} catch (e) {
		console.log(e);
	}
}

async function get({
	resourcePath,
	queryParams,
	logOutIfSessionInvalid = true,
	returnText = false,
	version,
	unauthorize = false,
	isBackend = false,
	withAccessToken = false,
	returnBlob=false
}) {
	let uri = getURI(isBackend, resourcePath);
	var options = {};
	options.headers = initOptionHeader();
	options.method = "GET";
	options.credentials = 'omit';
	if (withAccessToken == true || logOutIfSessionInvalid == true) {
		options.headers['Authorization'] = 'Bearer ' + _accessToken;
	} else if (!unauthorize) {
		options.headers['api_key'] = _apiKey;
	}

	if (version || configuration.apiVersion)
		options.headers.x_version = version ? version : configuration.apiVersion;
	if (configuration.apiVersion)
		options.headers.x_language = getData('LANGUAGE');
	if (queryParams)
		uri = uri + '?' + querystring.encode(cleanObj(queryParams));
	console.log('GET: ', uri, options);
	let response = await fetch(uri, options);
	if (response.status == '200') {
		if (returnText){
			let bodyText = await response.text()
			console.log('Response - ', response.status, ' - Body:', (bodyText ? json2Obj(bodyText) : bodyText));
			return { code: "OK", data: bodyText };
		}
		else if (returnBlob) {
			let blob = await response.blob();
			console.log('Response - ', response.status, ' - Body blob:', blob);
			return { code: "OK", data: blob ? blob : null };
		}
		else {
			let bodyText = await response.text()
			console.log('Response - ', response.status, ' - Body:', json2Obj(bodyText));
			return { code: "OK", data: bodyText ? json2Obj(bodyText) : null };
		}
	} else {
		let bodyText = await response.text()
		validateForceLogout(response, logOutIfSessionInvalid);
		return { code: response.status, bodyText: bodyText, error: json2Obj(bodyText) };
	}
}

async function sendDelete({
	resourcePath,
	queryParams,
	body,
	logOutIfSessionInvalid = true,
	isBackend = false
}) {
	let uri = getURI(isBackend, resourcePath);
	var options = {};
	options.headers = initOptionHeader();
	options.method = "DELETE";
	options.headers['Authorization'] = 'Bearer ' + _accessToken;
	options.credentials = 'omit';

	if (configuration.apiVersion)
		options.headers.x_version = configuration.apiVersion;

	options.headers.x_language = getData('LANGUAGE');
	if (body)
		options.body = JSON.stringify(body);
	if (queryParams)
		uri = uri + '?' + querystring.encode(cleanObj(queryParams));
	console.log('GET: ', uri, options);
	let response = await fetch(uri, options);
	let bodyText = await response.text()
	console.log('Response - ', response.status, ' - Body:', (bodyText ? json2Obj(bodyText) : bodyText));
	if (response.status == '200') {
		return { code: "OK", data: bodyText ? json2Obj(bodyText) : null };
	} else {
		validateForceLogout(response, logOutIfSessionInvalid);
		return { code: response.status, bodyText: bodyText, error: json2Obj(bodyText) };
	}

	//TODO: add token expire and validation later 
	// let accessToken;
	// if (withAccessToken)
	// {
	//   //check if token is not expired
	// }

}

async function put({
	resourcePath,
	body,
	queryParams,
	logOutIfSessionInvalid = true,
	isBackend = false
}) {
	let uri = getURI(isBackend, resourcePath);
	var options = {};
	options.headers = initOptionHeader();
	options.method = "PUT";
	options.headers['Authorization'] = 'Bearer ' + _accessToken;
	options.headers.x_language = getData('LANGUAGE');
	options.credentials = 'omit';
	if (configuration.apiVersion)
		options.headers.x_version = configuration.apiVersion;

	if (body)
		options.body = JSON.stringify(body);
	if (queryParams)
		uri = uri + '?' + querystring.encode(queryParams);
	console.log('PUT: ', uri, options);
	let response = await fetch(uri, options);
	let bodyText = await response.text()
	console.log('Response - ', response.status, ' - Body:', (bodyText ? json2Obj(bodyText) : bodyText));
	if (response.status == '200') {
		return { code: "OK", data: bodyText ? json2Obj(bodyText) : null };
	}
	else {
		validateForceLogout(response, logOutIfSessionInvalid);
		return { code: response.status, bodyText: bodyText, error: json2Obj(bodyText) };
	}
}

function is200OK(result) {
	if (result && result.status && result.status == '200')
		return true;
	else
		return false;
}

function cleanObj(obj) {
	for (var propName in obj) {
		if (obj[propName] === null || obj[propName] === undefined) {
			delete obj[propName];
		}
	}
	return obj;
}

async function uploadFileNew({
	resourcePath,
	fileData,
	body,
	logOutIfSessionInvalid = true,
	version,
	unauthorize = false,
	isBackend = false,
	withAccessToken = false,
	token = null,
}) {
	try {
		let uri = getURI(isBackend, resourcePath);

		var formData = new FormData();
		if (fileData) {
			console.log("fileData==", fileData);
			formData.append('file', fileData);
		}

		var options = {
			method: 'POST',
			body: formData,
			credentials: 'omit',
			headers: {},
		};

		if (withAccessToken == true || logOutIfSessionInvalid == true)
			options.headers['Authorization'] = 'Bearer ' + _accessToken;
		else if(token){
			options.headers['Authorization'] = 'Bearer ' + token;
		}
		else if (!unauthorize) {
			options.headers['api_key'] = _apiKey;
		}
		if (configuration.x_language)
			options.headers.x_language = getData('LANGUAGE');

		if (version || configuration.apiVersion)
			options.headers.x_version = version ? version : configuration.apiVersion;

		console.log('UPLOAT FILE POST: ', uri, options);
		let response = await fetch(uri, options);
		let bodyText = await response.text()
		console.log('Response - ', response.status, ' - Body:', (bodyText ? json2Obj(bodyText) : bodyText));
		if (response.status == '200') {
			return { code: "OK", data: bodyText ? json2Obj(bodyText) : null };
		} else {
			validateForceLogout(response, logOutIfSessionInvalid);
			return { code: response.status, bodyText: bodyText, error: json2Obj(bodyText) };
		}
	} catch (error) {
		console.log("process uploadFile exception:", error);
		validateForceLogout(error, true);
	}

}
